/**
 * Canonical list of upload sources. Every Cloudflare image upload must
 * declare what it's being used for so we can record it in the user_image
 * library with the right source_code (NOT NULL in the schema).
 *
 * Shared between server (Elysia route validation), web client (uploader
 * components), and mobile (image picker).
 */
export const USER_IMAGE_SOURCE_CODES = [
  "user_avatar",
  "pod_avatar",
  "mod_image",
  "frame_hero",
  "group_post_media",
  "group_post_comment_media",
  "mod_comment_media",
  "pod_message",
  "dm_message",
  "support_message",
  "retro_profile_bg",
  "retro_profile_flashbox",
  "retro_photo",
  "retro_skin",
  "trivia_image",
  "admin_upload",
  "card_photo",
  "card_snapshot",
  "card_send_message", // signer-message photo attachment (group-card sign composer, 2026-09-14)
  "legacy_card_image", // migrated legacy card_send_image composite (PRD 03 §10, 2026-09-10)
  "contact_photo", // member-uploaded contact photo (contact.photo_user_image_id, PRD 02 §5.1)
] as const;

export type UserImageSourceCode = (typeof USER_IMAGE_SOURCE_CODES)[number];
